<ng-container *transloco="let t; read: 'product-search'">
  <div class="componentContainer">
    <section class="xs12col componentHeader">
      <h1>{{t('title')}}</h1>
    </section>

    @if (('Permissions.BasketItems.CreateGlobal' | permission) && (connectionState$ | async)) {
      <section class="oneCol">
        <div class="xs12col m6col">
          <div class="boxContainer">
            <div class="box">
              <h2 class="padding-bottom-medium">{{t('chooseCompany')}}</h2>
              <app-company-basket-dropdown></app-company-basket-dropdown>
            </div>
          </div>
        </div>
      </section>
    }

    @if (tabletAndSmaller) {
      <section class="oneCol">
        <div class="xs12col">
          <div class="boxContainer">
            <div class="box">
              <app-scanner
                [isAdminView]="('Permissions.BasketItems.CreateGlobal' | permission)"
                [currentCompany]="currentCompany$ | async">
              </app-scanner>
            </div>
          </div>
        </div>
      </section>
    }

    @if ((connectionState$ | async)) {
      <section class="oneCol">
        <div class="xs12col">
          <div class="boxContainer">
            <div class="box">
              <app-product-grid
                [showActionCol]="false"
                [createProducts]="false"
                [reloadResults]="false"
                [loadAllProducts]="false"
                [isAdminView]="('Permissions.BasketItems.CreateGlobal' | permission)"
                [currentCompany]="currentCompany$ | async">
              </app-product-grid>
            </div>
          </div>
        </div>
      </section>
    }
  </div>
</ng-container>

